$(document).ready(function () {
	let $modalProduct = $("#modal-prd");

	$modalProduct.on('modal-loaded', function () {
		let $item = $modalProduct.find('[data-product]');
		let $modal = $modalProduct.closest('.modal');
		let id = $item.data('id');

		$modal.find('.prd-recommends-content').empty();
		$modal.find('.prd-similar-content').empty();

		$.get(`/catalog/product/${id}/modal/widgets`, {}, function (data) {
			if (data.view_recommends) {
				$modal.find('.prd-recommends-content').html(data.view_recommends);
			}

			if (data.view_similar) {
				$modal.find('.prd-similar-content').html(data.view_similar);
			}

			if (data.view_recommends || data.view_similar) {
				VegasCarousel.init();
			}
		});
	});

	$modalProduct.on('click', '.vg-shop-menu--similar .to-product', function () {
		let route = $(this).data('route');
		let $modal = $(this).closest('.modal');
		let $content = $modal.find('#prd-content');

		$.get(route, {}, function (data) {
			$content.html(data.view);
		});

		return false;
	});

});